import { FC } from 'react';
import { ICustomListItemProps } from './types';

export const CustomListItem: FC<ICustomListItemProps> = ({ children }) => (
  <div className={'mx-1 my-0 flex min-w-0 flex-1 items-center justify-between'}>{children}</div>
);
